import { FormattedMessage, useIntl } from "react-intl";
import View from "components/utils/View";
import {
  Grid,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import useStyles from "../paymentStyles";
import SrButton from "components/common/SrButton";
import { SrTitle } from "components/common";
import { MainItemsLayout } from "components/Layout";
import BankLogo from "components/utils/BankLogo";
import { PAYMENT_BUTTON_COMPONENTS } from "constants/index";

const Initial = ({ setPaymentButtonPage }) => {
  const intl = useIntl();
  const theme = useTheme();
  const classes = useStyles();
  const upMd = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <View translateTitleKey="menu.botonDePago">
      <SrTitle>
        <FormattedMessage id="ecommerce.botonDePago.heading" />
      </SrTitle>
      <MainItemsLayout
        leftContent={
          <div>
            <Grid item xs={12} container alignItems="center">
              <Box pb={4} pt={4}>
                <ul className={classes.list}>
                  <Box component="li" mb={1}>
                    <Typography>
                      {intl.formatMessage({
                        id: "ecommerce.botonDePago.ul.p1",
                      })}
                    </Typography>
                  </Box>
                  <Box component="li" mb={1}>
                    <Typography>
                      {intl.formatMessage({
                        id: "ecommerce.botonDePago.ul.p2",
                      })}
                    </Typography>
                  </Box>
                  <Box component="li" mb={1}>
                    <Typography>
                      {intl.formatMessage({
                        id: "ecommerce.botonDePago.ul.p3",
                      })}
                    </Typography>
                  </Box>
                  <Box component="li" mb={1}>
                    <Typography>
                      {intl.formatMessage({
                        id: "ecommerce.botonDePago.ul.p4",
                      })}
                    </Typography>
                  </Box>
                  <Box component="li" mb={1}>
                    <Typography>
                      {intl.formatMessage({
                        id: "ecommerce.botonDePago.ul.p5",
                      })}
                    </Typography>
                  </Box>
                </ul>
              </Box>
            </Grid>
            <Grid item xs={12} container alignItems="center">
              <Box pb={4}>
                <Box pb={2}>
                  <Typography variant="h2">
                    {intl.formatMessage({
                      id: "ecommerce.botonDePago.newProduct",
                    })}
                  </Typography>
                </Box>
                <SrButton
                  color="primary"
                  variant="contained"
                  onClick={() =>
                    setPaymentButtonPage(PAYMENT_BUTTON_COMPONENTS[1])
                  }
                >
                  {intl.formatMessage({
                    id: "ecommerce.botonDePago.requestButton",
                  })}
                </SrButton>
              </Box>
            </Grid>
          </div>
        }
        rightContent={
          <Grid item xs={12} md={6} container justifyContent="center">
            <img
              height={250}
              src="/boton-de-pago/boton-de-pago.svg"
              alt={intl.formatMessage({
                id: "ecommerce.botonDePago.whatIs.title",
              })}
            />
          </Grid>
        }
      />
      <Grid
        item
        xs={12}
        container
        justifyContent={upMd ? "space-around" : "center"}
      >
        <BankLogo bankName="citibanamex" className={classes.bankLogo} />
        <BankLogo bankName="banorte" className={classes.bankLogo} />
        <BankLogo bankName="inbursa" className={classes.bankLogo} />
        <BankLogo bankName="scotiabank" className={classes.bankLogo} />
        <BankLogo bankName="santander" className={classes.bankLogo} />
        <BankLogo bankName="hsbc" className={classes.bankLogo} />
        <BankLogo bankName="bbva" className={classes.bankLogo} />
        <BankLogo bankName="copel" className={classes.bankLogo} />
      </Grid>
    </View>
  );
};

export default Initial;
